import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import TopBar from "@/components/TopBar";
import CorporateHero from "@/components/CorporateHero";

const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const CorporateAbout = lazy(() => import("@/components/CorporateAbout"));
const ContactForm = lazy(() => import("@/components/ContactForm"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <>
      <Helmet>
        <title>TGF – Top Gear Funnels | פתרונות דיגיטליים מקצועיים</title>
        <meta name="description" content="TGF – פתרונות דיגיטליים מקצועיים: בניית אתרים, חנויות איקומרס, אינטגרציות שופיפיי, ממשקים מותאמים ואוטומציות שיווקיות." />
        <meta property="og:title" content="TGF – Top Gear Funnels | פתרונות דיגיטליים מקצועיים" />
        <meta property="og:description" content="TGF – פתרונות דיגיטליים מקצועיים: בניית אתרים, חנויות איקומרס, אינטגרציות שופיפיי, ממשקים מותאמים ואוטומציות שיווקיות." />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "TGF – Top Gear Funnels",
            "description": "פתרונות דיגיטליים מקצועיים: בניית אתרים, חנויות איקומרס, אינטגרציות שופיפיי, ממשקים מותאמים ואוטומציות",
            "url": window.location.origin,
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "Customer Service",
              "availableLanguage": "he",
            },
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <TopBar />
        <CorporateHero />
        <Suspense fallback={null}>
          <ServicesSection />
          <CorporateAbout />

          {/* Contact Form Section */}
          <section className="py-12 sm:py-20 px-4 bg-secondary/30">
            <div className="container mx-auto max-w-2xl">
              <div id="contact-form">
                <ContactForm
                  formTitle="בואו נדבר על הפרויקט שלכם"
                  formSubtitle="מלאו את הפרטים ונחזור אליכם תוך 24 שעות עם הצעה מותאמת"
                />
              </div>
            </div>
          </section>

          <Footer />
        </Suspense>
      </div>
    </>
  );
};

export default Index;
